// extracted by mini-css-extract-plugin
export default {"order":"order-details_order__q24Kc"};